const getEmptyQueryBuilderGroup = orCondition => {
    const group = {
        condition: orCondition ? "or" : "and",
        rules: [],
        valid: true,
        description: "",
        not: false,
    };
    return group;
};
export default getEmptyQueryBuilderGroup;
